/*
 * Resilia roadmap — the timeline line fills as the reader scrolls through it, and steps fade in once.
 * Scroll work only runs while the section is on screen.
 */
(() => {
  const setup = (root) => {
    if (root.classList.contains('is-ready')) return;
    const timeline = root.querySelector('[data-roadmap-timeline]');
    const fill = root.querySelector('[data-roadmap-fill]');
    const items = [...root.querySelectorAll('[data-roadmap-item]')];
    if (!timeline || !fill || !items.length) return;

    root.classList.add('is-ready');

    // Fill starts as soon as the timeline enters the lower part of the screen and tracks the reader down it
    const update = () => {
      const rect = timeline.getBoundingClientRect();
      const progress = (window.innerHeight * 0.8 - rect.top) / rect.height;
      fill.style.height = `${Math.max(0, Math.min(1, progress)) * 100}%`;
    };

    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        update();
        ticking = false;
      });
    };

    // Attach the scroll listener only while the timeline is visible. Capture phase on document
    // catches scrolling of any container, not just the window; the multi-threshold observer
    // also updates the fill by itself, as a fallback if no scroll events arrive.
    const thresholds = Array.from({ length: 21 }, (_, i) => i / 20);
    const listenerOptions = { passive: true, capture: true };
    new IntersectionObserver(
      ([entry]) => {
        update();
        if (entry.isIntersecting) document.addEventListener('scroll', onScroll, listenerOptions);
        else document.removeEventListener('scroll', onScroll, listenerOptions);
      },
      { threshold: thresholds }
    ).observe(timeline);
    window.addEventListener('resize', onScroll, { passive: true });

    const reveal = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          reveal.unobserve(entry.target);
        });
      },
      { threshold: 0.2, rootMargin: '0px 0px -60px 0px' }
    );
    items.forEach((item) => reveal.observe(item));
  };

  const init = () => document.querySelectorAll('[data-roadmap]').forEach(setup);
  init();
  document.addEventListener('shopify:section:load', init);
})();
